// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface ObjectReplicationPoliciesListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface ObjectReplicationPoliciesDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface ObjectReplicationPoliciesCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface ObjectReplicationPoliciesGetOptionalParams extends OperationOptions {}
